import { render, staticRenderFns } from "./LoginP.vue?vue&type=template&id=61a9963c&scoped=true&"
import script from "./LoginP.vue?vue&type=script&lang=js&"
export * from "./LoginP.vue?vue&type=script&lang=js&"
import style0 from "./LoginP.vue?vue&type=style&index=0&id=61a9963c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a9963c",
  null
  
)

export default component.exports